(function () {
  'use strict';

  angular.module('ringbaPortal').component('changelogObjectBtnAction', {
    controllerAs: 'vm',
    bindings: {
      objectId: '<',
      objectName: '<',
      objectType: '@',
      customClass: '@',
      disabled: '<'
    },
    controller: ChangelogObjectPopoverController,
    templateUrl: '/scripts/shared/components/changelog/changelog-object-popover/changelog-object-btn-action.view.html'
  });

  function ChangelogObjectPopoverController(
    authService,
    featureFlags
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.hideChangelogPopover = hideChangelogPopover;

    function onInit() {
      vm.enableChangelog = authService.authentication.isSuper || featureFlags.isOn('changelog');
    }

    function hideChangelogPopover() {
      vm.isChangelogPopoverOpen = false;
    }
  }

})();
